/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import axios from "axios";
import BaseUrl from "@/libs/base-url";

export default function axiosSetUp() {
  axios.defaults.baseURL = BaseUrl.mainBase;
  axios.interceptors.request.use(
    config => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`;
        // config.headers.setAttribute('Authorization', token)
      }
      return config;
    },
    error => Promise.reject(error)
  );
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.message === "Network Error") {
      window.location.href = "/error-network";
    }
    if (error.response.status === 401) {
      localStorage.removeItem("accessToken");

      // Notify other tabs about forced logout (token expired/invalid)
      if (typeof window !== "undefined" && "BroadcastChannel" in window) {
        const authChannel = new BroadcastChannel("auth-sync");
        authChannel.postMessage({ type: "logout" });
        authChannel.close();
      }

      window.location.href = "/login";
      return Promise.reject(error);
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      return axios(originalRequest);
    }
    return Promise.reject(error);
  }
);
